<template>
	<div class="row" v-if="setting">
		<div class="col-md-6">
			<card header-classes="bg-dark">
				<template slot="header">
					<h3 class="mb-0 text-white">ตั้งค่าเว็บไซต์</h3>
				</template>
				<form @submit.prevent="saveConfig">
					<base-input
						label="ชื่อเว็บไซต์"
						placeholder="ชื่อเว็บไซต์"
						v-model="setting.title"
					/>

					<div class="row">
						<div class="col-md-6">
							<base-input label="เกม" :value="setting.game.toUpperCase()" readonly />
						</div>
						<div class="col-md-6">
							<base-input
								label="Agent"
								placeholder="Agent"
								:value="setting.agent"
								readonly
							/>
						</div>
					</div>
					<base-input label="เทิร์น" v-if="isCasino">
						<el-select v-model="setting.turnType" placeholder="เทิร์น">
							<el-option label="เทิร์นโอเวอร์" value="turnover" />
							<el-option label="เทิร์นเงิน" value="turn" />
						</el-select>
					</base-input>

					<hr class="my-3" />
					<div class="row">
						<div class="col-md-6">
							<base-input
								label="ลิงก์เข้าเล่นเกม"
								placeholder="ลิงก์เข้าเล่นเกม"
								v-model.number="setting.gameLink"
							/>
						</div>
						<div class="col-md-6">
							<base-input
								label="ลิงก์ไลน์ (แจ้งปัญหา)"
								placeholder="ลิงก์ไลน์ (แจ้งปัญหา)"
								v-model.number="setting.lineLink"
							/>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<base-input
								label="ลิงก์ดาวโหลด (iOS)"
								placeholder="ลิงก์ดาวโหลด (iOS)"
								v-model.number="setting.linkDownloadIOS"
							/>
						</div>
						<div class="col-md-6">
							<base-input
								label="ลิงก์ดาวโหลด (Android)"
								placeholder="ลิงก์ดาวโหลด (Android)"
								v-model.number="setting.linkDownloadAndroid"
							/>
						</div>
					</div>

					<hr class="my-3" />
					<base-input
						label="Line Token (แจ้งเตือนรายการฝาก - ถอน)"
						placeholder="Line Token"
						v-model="setting.lineToken"
						v-if="hasFeature('lineNotify')"
					/>

					<hr class="my-3" />
					<upload label="โลโก้เว็บไซต์" setting="logo" />

					<hr class="my-3" />
					<div class="row">
						<div class="col-md-6">
							<base-input
								label="ยอดคงเหลือขั้นต่ำ (เติมเครดิต)"
								placeholder="ยอดคงเหลือขั้นต่ำ (เติมเครดิต)"
								v-model.number="setting.minCredit"
							/>
						</div>
						<div class="col-md-6">
							<base-input
								label="ยอดถอนขั้นต่ำ"
								placeholder="ยอดถอนขั้นต่ำ"
								v-model.number="setting.minWithdraw"
							/>
						</div>
					</div>

					<hr class="my-3" />
					<div class="form-group">
						<label class="form-control-label">ระบบเว็บไซต์</label>
						<div class="cb-wrapper">
							<base-checkbox v-model="setting.functions.depositToGame">
								รันรายการฝากเข้าเกม
							</base-checkbox>
						</div>
						<div class="cb-wrapper">
							<base-checkbox v-model="setting.functions.withdrawFromGame">
								ถอนเงินจากเกม
							</base-checkbox>
						</div>
						<div class="cb-wrapper">
							<base-checkbox v-model="setting.functions.bonusHunterGuard">
								ตรวจสอบรายการถอน (สมาชิกใหม่)
							</base-checkbox>
						</div>
					</div>

					<div class="mt-3">
						<base-button native-type="submit" type="default" :disabled="loading">
							บันทึกข้อมูล
						</base-button>
					</div>
				</form>
			</card>
		</div>
		<div class="col-md-6">
			<amb-payment-panel :setting="setting.ambPayment" />
		</div>
		<div class="col-md-6" v-if="setting.game === 'betflix'">
			<betflix-game-panel :betflixGames="setting.betflixGames" />
		</div>
		<div class="col-md-6" v-if="setting.game === 'ambbet'">
			<ambbet-panel :ambbetGames="setting.ambbetGames" />
		</div>
	</div>
</template>

<script>
import { Select, Option } from 'element-ui'
import Upload from '../backend-components/Common/Upload'
import BetflixGamePanel from '../backend-components/Setting/BetflixGamePanel'
import AmbbetPanel from '../backend-components/Setting/AmbbetPanel'
import AMBPaymentPanel from '../backend-components/Setting/AMBPaymentPanel'

import SettingService from '../services/setting.service'
import { mapGetters } from 'vuex'

export default {
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
		Upload,
		BetflixGamePanel,
		AmbbetPanel,
		'amb-payment-panel': AMBPaymentPanel,
	},
	data() {
		return {
			loading: false,
			setting: null,
			supportGames: [],
			isCasino: false,
		}
	},
	computed: {
		...mapGetters('auth', ['hasFeature']),
	},
	methods: {
		saveConfig() {
			this.loading = true
			SettingService.saveSetting(this.setting)
				.then(({ message }) => {
					this.$notify({ type: 'success', message })
				})
				.catch(({ message }) => {
					this.$notify({ type: 'danger', message })
				})
				.finally(() => {
					this.loading = false
				})
		},
		reloadSetting() {
			SettingService.fetchSetting().then((res) => {
				this.setting = res.setting
				this.supportGames = res.supportGames
				this.isCasino = res.isCasino
			})
		},
	},
	created() {
		this.reloadSetting()
	},
}
</script>
